import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import intlMessages from './translations'
import intlMessagesClaims from '../translations'

import { Layout, Content, Container, PageTitle } from 'src/components/Layout'
import List from 'src/components/List'
import styles from './InvestigatingOfficer.module.less'

class InvestigatingOfficer extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  getListItems = () => {
    const { intl } = this.props

    return [
      {
        leftIcon: ['far', 'siren'],
        name: intl.formatMessage(intlMessages.investigatingOfficerNoOfficer),
        action: 'no_police',
        url: '/claims/form',
        rightIcon: 'right',
        hideArrow: true,
        hideArrowOnMobile: true,
      },
      {
        leftIcon: ['far', 'siren-on'],
        name: intl.formatMessage(intlMessages.investigatingOfficerThereWasOfficer),
        action: 'add_police',
        url: '/claims/investigating-officer/new',
        rightIcon: 'right',
        iconWidth: 30,
        hideArrow: true,
      },
    ]
  }

  handleClick = item => {
    if (item.action === 'no_police') {
      this.props.setOfficer(null)
    }
  }

  render() {
    const { intl } = this.props
    return (
      <Layout className='m-claims-investigating-officer claims-list'>
        <Content>
          <PageTitle
            title={intl.formatMessage(intlMessages.investigatingOfficerHeadline)}
            subtitle={intl.formatMessage(intlMessagesClaims.claimsFillOutTheForm)}
          />
          <Container className={styles.list}>
            <List
              noMargin={true}
              items={this.getListItems()}
              onClick={this.handleClick}
              isColumn={true}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default injectIntl(InvestigatingOfficer)
